module.exports = {"140421100":"韩店镇","140421101":"苏店镇","140421102":"荫城镇","140421103":"西火镇","140421104":"八义镇","140421105":"贾掌镇","140421200":"郝家庄乡","140421201":"西池乡","140421202":"北呈乡","140421203":"东和乡","140421204":"南宋乡","140421400":"振兴新区","140421406":"工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140421.json
// module id = 258
// module chunks = 0